import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bsejeyw",
  "use": "icon-bsejeyw-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" viewBox=\"0 0 15 14\" id=\"icon-bsejeyw\">\n<path fill-rule=\"evenodd\" fill=\"gray\" d=\"M4.958,13.930 L4.696,9.914 L0.937,7.935 L2.274,7.592 C4.819,6.866 7.201,5.656 9.287,4.028 L6.749,2.998 L14.669,0.198 L12.064,8.276 L11.267,6.067 C9.142,9.044 5.851,12.884 5.816,12.926 L4.958,13.930 ZM3.791,8.233 L5.730,9.253 L5.857,11.218 C7.074,9.760 11.676,3.984 11.676,3.984 L11.853,5.136 L12.927,1.982 L9.886,3.112 L11.213,3.518 C11.213,3.518 6.221,7.407 3.790,8.234 L3.791,8.233 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bsejeyw.svg
// module id = ynrA
// module chunks = 12